import type { FaireProductEntity } from "../../entity_types/product";

export const p_k8z4x554qm: FaireProductEntity = {
  token: "p_k8z4x554qm",
  type: "product",
  name: "Sacred Chakra Wellness Stone Kit",
  brandToken: "b_6k5xkw1g4n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5c5be8ec4fec9c01e4183b1ef15dcd0a466eee5e659d3197878866baa235675a.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.39,
  description: "",
  tags: [],
  msrpDollars: 2.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:57.451Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
